export default __webpack_public_path__ + "static/media/MAP.c974d5b9.jpg";